export default "/_next/static/chunks/fonts/aquatico-regular-188cc059a331888e2dfd3c9319f7fee0.woff";